import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "quantity", "destroy"]

  connect() {
    // If it's a persisted record, set the required attribute
    if (this.element.dataset.persisted === "true") {
      this.selectTarget.required = true
    }
  }

  handleChange(event) {
    const selected = event.target.value
    if (selected) {
      this.quantityTarget.value = this.quantityTarget.value || "1"
    } else {
      this.quantityTarget.value = ""
      this.destroyTarget.value = "1"
    }
  }

  remove(event) {
    // Prevent the nested-form#remove from being called if we're just clearing the selection
    if (this.selectTarget.value === "") {
      event.stopPropagation()
    }
    this.destroyTarget.value = "1"
  }
}
